import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Badge, Button, Spinner, Alert, Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const KurbanlikHayvanListesi = () => {
  document.title = "Kurbanlık Hayvan Listesi | HarmanaGEL";

  const [hayvanlar, setHayvanlar] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");

  const [detailModal, setDetailModal] = useState(false);
  const [selectedHayvan, setSelectedHayvan] = useState(null);

  const fetchHayvanlar = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/KURBANLIK_HAYVAN_LISTESI?$top=500&$orderby=ID desc&$expand=ILANLAR($select=AD)`,
        { headers: getAuthHeaders() }
      );
      const result = await response.json();
      if (result && result.value) setHayvanlar(result.value);
    } catch (err) {
      setError("Hayvanlar yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHayvanlar();
  }, []);

  const durumBadge = (durum) => {
    const renkler = { "Satışta": "success", "Satıldı": "secondary", "Rezerve": "warning", "Pasif": "danger" };
    return <Badge color={renkler[durum] || "secondary"}>{durum || "-"}</Badge>;
  };

  const handleViewDetail = (hayvan) => {
    setSelectedHayvan(hayvan);
    setDetailModal(true);
  };

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
    },
    {
      header: "İlan",
      accessorKey: "ILANLAR",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const i = cell.getValue();
        return i ? <span className="fw-medium">{i.AD}</span> : <span className="text-muted">İlan #{cell.row.original.ILAN_ID}</span>;
      },
    },
    {
      header: "Küpe No",
      accessorKey: "KUPE_NO",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => <span className="font-monospace">{cell.getValue() || "-"}</span>,
    },
    {
      header: "Tahmini Kilo",
      accessorKey: "TAHMINI_KILO",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const v = cell.getValue();
        return v != null ? <span className="fw-medium">{v} kg</span> : "-";
      },
    },
    {
      header: "Durum",
      accessorKey: "DURUM",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => durumBadge(cell.getValue()),
    },
    {
      header: "İşlemler",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cellProps) => {
        const h = cellProps.row.original;
        return (
          <Button color="info" size="sm" outline onClick={() => handleViewDetail(h)}>
            <i className="bx bx-detail" />
          </Button>
        );
      },
    },
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Kurbanlık Hayvan Listesi" />

          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">Kurbanlık Hayvanlar</h4>
                    <Button color="primary" size="sm" onClick={fetchHayvanlar} disabled={isLoading}>
                      <i className="bx bx-refresh me-1" />
                      Yenile
                    </Button>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={hayvanlar}
                      isGlobalFilter={true}
                      SearchPlaceholder="Hayvan ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <Modal isOpen={detailModal} toggle={() => setDetailModal(false)} centered>
        <ModalHeader toggle={() => setDetailModal(false)}>
          Hayvan Detayı
        </ModalHeader>
        <ModalBody>
          {selectedHayvan && (
            <>
              <p><strong>İlan:</strong> {selectedHayvan.ILANLAR?.AD || `İlan #${selectedHayvan.ILAN_ID}`}</p>
              <p><strong>Küpe No:</strong> {selectedHayvan.KUPE_NO || "-"}</p>
              <p><strong>Tahmini Kilo:</strong> {selectedHayvan.TAHMINI_KILO != null ? `${selectedHayvan.TAHMINI_KILO} kg` : "-"}</p>
              <p><strong>Durum:</strong> {durumBadge(selectedHayvan.DURUM)}</p>
              {selectedHayvan.FOTO_URL && (
                <div className="text-center">
                  <img src={selectedHayvan.FOTO_URL} alt="Hayvan" className="img-fluid rounded" style={{ maxHeight: 300 }} />
                </div>
              )}
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setDetailModal(false)}>Kapat</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default KurbanlikHayvanListesi;
